var exports = {
  "kL": "xa15a2ab7--bcb67a--container",
  "XG": "xa15a2ab7--bcb67a--scroller",
  "ok": "xa15a2ab7--bcb67a--scroller--bordered",
  "mT": "xa15a2ab7--bcb67a--thumbs-wrapper",
  "bz": "xa15a2ab7--bcb67a--thumbs-wrapper--bounded",
};

module.exports = exports;
